<template>
  <div>
      <router-view></router-view>
      <tabbar v-model="active"  safe-area-inset-bottom @change="switchTab" active-color="#ff976a" :zIndex="1001">
          <tabbar-item icon="home-o" :to="{name:'index'}" :name="1"> 首页</tabbar-item>
          <tabbar-item icon="contact" :to="{name:'my'}" :name="2">我的</tabbar-item>
      </tabbar>
  </div>
</template>

<script>
    import {Tabbar, TabbarItem} from 'vant';
    export default {
        name: 'Main',
        components: {
            Tabbar,
            TabbarItem
        },
        methods:{
            switchTab:function(e){
                this.active =   e;
            }
        },
        data() {
            return {
                active:1
            }
        },
        watch: {
            active(newValue, oldValue) {
                console.log(newValue)
            }
        },
        mounted(options) {
            this.$nextTick(() => {
                var currentUrl = window.location.pathname
                if(currentUrl == '/uc'){
                  this.active = 2
                }else{
                  this.active = 1
                }
            })

        }
    }
</script>
